module.exports = __webpack_public_path__ + "c47a83ca4beea95831b76bba75225230.svg";